import gql from 'graphql-tag'
import { get } from 'ts-object-path'
import { useQuery } from '@apollo/react-hooks'
import {
  ProfitChartByAccountId_accountsCharts,
  ProfitChartByAccountId_accountsChartsVariables
} from '../../../_generated/ProfitChartByAccountId_accountsCharts'
import { Precision } from '../../../_generated/globalTypes'

export const QUERY = gql`
query ProfitChartByAccountId_accountsCharts($id: ID!, $precision: Precision!) {
  charts {
    byAccountId(id: $id) {
      id: accountId
      profit(precision: $precision) {
        values
        begin
        valuesCount
        labels
        currency
      }
    }
  }
}`

export type Q = ProfitChartByAccountId_accountsCharts
export type V = ProfitChartByAccountId_accountsChartsVariables
export type R = Q['charts']['byAccountId']['profit']

export const parseData = (data: Q): R => {
  return get(data, p=> p.charts.byAccountId.profit)
}

export function Use(clientId: string) {
  const query = useQuery<Q, V>(
      QUERY,
      {
          variables: {
              id: clientId,
              precision: Precision.MONTH
          }
      }
  )

  const { loading, error, data } = query

  return { loading, error, data: parseData(data) }
}
